<template>
  <div class="user-page d-flex">
    <div class="user-page--content px-2 py-2 px-md-4 py-md-4">
      <UserInfo v-if="$auth.isAuthenticated" />
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import UserInfo from "@/components/user/UserInfo";

export default {
  name: "User",
  components: {
    UserInfo,
  },
  computed: {
    ...mapGetters("agency", ["currentAgency", "isAgencyConnecting"]),
  },
};
</script>

<style lang="scss">
.user-page {
  width: 100%;
  height: 100%;
  &--content {
    width: 100%;
    height: 100%;
    overflow-x: hidden;
    overflow-y: auto;
  }
}
</style>
